import { ContainerModule, interfaces } from "inversify";
import { VirtualAgentDataApi, virtualAgentDataRTTI } from "~/modules/virtualAgentData/Definitions";
import { VirtualAgentDataImpl } from "~/modules/virtualAgentData/VirtualAgentDataImpl";

export const virtualAgentModule = new ContainerModule((bind: interfaces.Bind) => {
    bind<VirtualAgentDataApi>(virtualAgentDataRTTI).to(VirtualAgentDataImpl).inSingletonScope();
});
